import { useRestrictforNotLogged } from 'src/hooks';

export const useRunAllHooksOnEachRenderReactPage = () => {
    useRestrictforNotLogged();
};
